import React from 'react';
import './BenefitsOfPrequalSection.scss';
import Button from '../../../components/Button/Button';

export function BenefitsOfPrequalSection({getPrequalified}) {
  return (
    <>
      <div className='prequal--web-ford-motion-benefits-of-prequal-section'>
        <div className='prequal--web-ford-motion-benefits-image' />
        <div className='prequal--web-ford-motion-benefits-content'>
          <div className='prequal--web-ford-motion-benefits-title'>
            <span>Why Should I Prequalify ?</span>
          </div>
          <div>
            <div className='prequal--web-ford-motion-benefits-detail'>
              <span className='prequal--web-ford-motion-benefits-detail-text'>Know your Budget </span>
              <span className='prequal--web-ford-motion-benefits-detail-subtext'>
                Use your prequalified amount to confidently explore
                <span className='desktop-break'> vehicles within your price range. </span>
              </span>
              <br />
            </div>
            <div className='prequal--web-ford-motion-benefits-detail'>
              <span className='prequal--web-ford-motion-benefits-detail-text'>Save Time at the Dealership </span>
              <span className='prequal--web-ford-motion-benefits-detail-subtext'>
                Determine your financing eligibility before you even
                <span className='desktop-break'> step foot in a dealership. </span>
              </span>
              <br />
            </div>
            <div className='prequal--web-ford-motion-benefits-detail'>
              <span className='prequal--web-ford-motion-benefits-detail-text'>Keep your Credit Safe</span>
              <span className='prequal--web-ford-motion-benefits-detail-subtext'>
                See your financing options with zero impact on your
                <span className='desktop-break'> credit score. </span>
              </span>
            </div>
          </div>
          <div>
            <Button
              dataTestId='get-prequalified-button'
              label='Get Prequalified'
              onClick={() => getPrequalified(false)}
              buttonStyle='primary'
            />
          </div>
        </div>
      </div>
    </>
  );
}
